import { useQueryClient } from 'react-query'

import { useQueryApi, useMutationApi } from 'utils/api'
import { apiPaths, handleError, queryKeys, validateStatus } from './config'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { AxiosError } from 'axios'
import type {
  TPSSummary,
  TRhkExists,
  TSyncToEkinResponse,
  TMulaiPelaksanaanRequestBody,
  SKPStatus,
} from 'types/kinerja-ps-pegawai'
import type { UseQueryOptions } from 'react-query'

export function useAPIGetSummary({
  periodId,
  ...options
}: UseQueryOptions<TPSSummary> & { periodId: string }) {
  return useQueryApi<TPSSummary>(apiPaths.summary(periodId), {
    queryKey: [queryKeys.API_GET_SUMMARY, periodId],
    axiosConfig: {
      validateStatus,
    },
    queryConfig: {
      useErrorBoundary: false,
      ...options,
    },
    errorHandlerFn: handleError,
  })
}

export function useAPIGetExistRHK({
  periodId,
  ...options
}: UseQueryOptions<TRhkExists> & { periodId: string }) {
  return useQueryApi<TRhkExists>(apiPaths.rhkExists(periodId), {
    queryKey: [queryKeys.API_GET_RHK_EXISTS, periodId],
    axiosConfig: {
      validateStatus,
    },
    queryConfig: {
      useErrorBoundary: true,
      ...options,
    },
    errorHandlerFn: handleError,
  })
}

export function useAPISyncToEkin() {
  const { period } = usePeriodContext()
  const queryClient = useQueryClient()

  return useMutationApi<
    TSyncToEkinResponse,
    AxiosError,
    TMulaiPelaksanaanRequestBody
  >(() => apiPaths.syncToEkin, {
    axiosConfig: { method: 'POST' },
    mutationConfig: {
      onSettled() {
        queryClient.invalidateQueries([queryKeys.API_GET_SUMMARY, period.id])
      },
    },
  })
}

export function useAPIGetStatus({
  periodId,
  ...options
}: UseQueryOptions<SKPStatus> & { periodId: string }) {
  return useQueryApi<SKPStatus>(apiPaths.status(periodId), {
    queryKey: [queryKeys.API_GET_STATUS, periodId],
    axiosConfig: {
      validateStatus,
    },
    queryConfig: {
      useErrorBoundary: false,
      ...options,
    },
    errorHandlerFn: handleError,
  })
}
